(function waitForWarehouse() {
  var input = document.querySelector('.search-bar__input');
  if (!input) { setTimeout(waitForWarehouse, 200); return; }

  // ── BLOCK WAREHOUSE SEARCH COMPLETELY ──
  var form = input.closest('form');
  if (form) {
    // Clone form to remove ALL Warehouse listeners
    var newForm = form.cloneNode(true);
    form.parentNode.replaceChild(newForm, form);
    
    // Get fresh input reference after clone
    var input = newForm.querySelector('.search-bar__input');
    
    // Block form submit — handle it ourselves
      newForm.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var q = input.value.trim();
      if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last';
    }, true);
  }

  (function () {
    'use strict';

    const input         = document.querySelector('.search-bar__input');
    const searchBar     = document.querySelector('.search-bar');
    const resultsDiv    = document.querySelector('.search-bar__results');
    const defaultState  = document.getElementById('hlm-default-state');
    const resultsState  = document.getElementById('hlm-results-state');
    const noResults     = document.getElementById('hlm-no-results');
    const noResultsQ    = document.getElementById('hlm-no-q');
    const resultsGrid   = document.getElementById('hlm-results-grid');
    const resultsFooter = document.getElementById('hlm-results-footer');
    const viewAllLink   = document.getElementById('hlm-view-all');
    const youMight      = document.getElementById('hlm-you-might');
    const bestsellers   = document.getElementById('hlm-bestsellers');

    if (!input || !resultsDiv) return;

    let debounceTimer     = null;
    let bestsellersLoaded = false;
    let lastQuery         = '';
    let hasTyped          = false;

    const BESTSELLER_HANDLES = [
      '10-olive-wood-holding-hand-crosses-with-red-gift-velvet-bags-from-bethlehem',
      '10mm-rosary-beads-500-beads-bethlehem-olive-wood',
      '12-tribes-or-children-of-israel-ephod-hoshen-breastplate-mezuzah-top-quality-3-inches-with-scroll',
      '14-stations-cross-13-5-inches',
      'holy-land-market-unisex-genuine-leather-biblical-sandals-jesus-yashua-style-ii',
      'holy-land-market-large-holy-blessed-anointing-oil-from-the-holy-land'
    ];

    // ---------- STATE FUNCTIONS ----------

    function forceShowResults() {
      resultsDiv.setAttribute('aria-hidden', 'false');
      resultsDiv.style.display    = 'block';
      resultsDiv.style.visibility = 'visible';
      resultsDiv.style.opacity    = '1';
      if (searchBar) searchBar.classList.add('is-expanded');
      const wrapper = document.querySelector('.search-bar__inner');
      if (wrapper) {
        wrapper.style.display    = 'block';
        wrapper.style.visibility = 'visible';
        wrapper.style.opacity    = '1';
      }
      const animation = document.querySelector('.search-bar__inner-animation');
      if (animation) {
        animation.style.display    = 'block';
        animation.style.visibility = 'visible';
        animation.style.opacity    = '1';
      }
      const skeleton = document.querySelector('.skeleton-container');
      if (skeleton) skeleton.style.display = 'none';
    }

    function showDefaultState() {
      if (defaultState)  defaultState.style.display  = 'block';
      if (resultsState)  resultsState.style.display  = 'none';
      if (noResults)     noResults.style.display     = 'none';
      if (resultsFooter) resultsFooter.style.display = 'none';
    }

    function showResults() {
      if (defaultState) defaultState.style.display = 'none';
      if (resultsState) resultsState.style.display = 'block';
      if (noResults)    noResults.style.display    = 'none';
    }

    function showNoResults(q) {
      if (defaultState) defaultState.style.display = 'none';
      if (resultsState) resultsState.style.display = 'none';
      if (noResults)    noResults.style.display    = 'block';
      if (noResultsQ)   noResultsQ.textContent     = q;
    }

    function closeDropdown() {
      hasTyped = false;
      if (searchBar) searchBar.classList.remove('is-expanded');
      resultsDiv.setAttribute('aria-hidden', 'true');
      resultsDiv.style.display = 'none';
      const inner = document.querySelector('.search-bar__inner');
      if (inner) inner.style.display = 'none';
      const anim = document.querySelector('.search-bar__inner-animation');
      if (anim) anim.style.display = 'none';
      lastQuery = '';
    }

    function resetToDefault() {
      hasTyped          = false;
      bestsellersLoaded = false;
      forceShowResults();
      showDefaultState();
      loadBestsellers();
    }

    // ---------- HELPERS ----------

    function formatPrice(price) {
      if (!price) return '';
      const num = parseFloat(price);
      if (isNaN(num) || num === 0) return '';
      return '$' + num.toFixed(2).replace(/\.00$/, '');
    }

    function getImage(p) {
      if (p.featured_image) {
        if (typeof p.featured_image === 'string') return p.featured_image;
        if (p.featured_image.url) return p.featured_image.url;
      }
      if (p.image) {
        if (typeof p.image === 'string') return p.image;
        if (p.image.src) return p.image.src;
        if (p.image.url) return p.image.url;
      }
      if (p.images && p.images[0]) {
        return typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || p.images[0].url || '');
      }
      return '';
    }

    function buildCard(p) {
      const price = formatPrice(p.price_min || p.price);
      const img   = getImage(p);
      const url   = p.url || '/products/' + p.handle;
      return '<a href="' + url + '" class="hlm-product-card">'
        + '<div class="hlm-product-img">'
        + (img ? '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' : '')
        + '</div>'
        + '<div class="hlm-product-info">'
        + '<p class="hlm-product-title">' + p.title + '</p>'
        + (price ? '<p class="hlm-product-price">' + price + '</p>' : '')
        + '</div></a>';
    }

    function buildCardFromProduct(p) {
      const price = formatPrice(p.price_min || (p.variants && p.variants[0] && p.variants[0].price));
      const img   = getImage(p);
      return '<a href="/products/' + p.handle + '" class="hlm-product-card">'
        + '<div class="hlm-product-img">'
        + (img ? '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' : '')
        + '</div>'
        + '<div class="hlm-product-info">'
        + '<p class="hlm-product-title">' + p.title + '</p>'
        + (price ? '<p class="hlm-product-price">' + price + '</p>' : '')
        + '</div></a>';
    }

    // ---------- BESTSELLERS ----------

    function loadBestsellers() {
      if (bestsellersLoaded) return;
      bestsellersLoaded = true;
      var fetches = BESTSELLER_HANDLES.map(function(handle) {
        return fetch('/products/' + handle + '.json')
          .then(function(r) { return r.json(); })
          .then(function(d) { return d.product; })
          .catch(function() { return null; });
      });
      Promise.all(fetches).then(function(products) {
        var valid = products.filter(Boolean);
        if (bestsellers) {
          bestsellers.innerHTML = valid.length
            ? valid.map(buildCardFromProduct).join('')
            : '<p class="hlm-loading">Could not load.</p>';
        }
      });
    }

    // ---------- SEARCH ----------

    function doSearch(q) {
      if (!q || q.length < 2) return;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product'
        + '&resources[limit]=6'
        + '&resources[options][prefix]=last'
        + '&resources[options][unavailable_products]=last')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          // If user cleared input while fetching — ignore results
          if (!input.value.trim()) { resetToDefault(); return; }
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) { showNoResults(q); return; }
          showResults();
          if (resultsGrid)   resultsGrid.innerHTML       = products.slice(0, 6).map(buildCard).join('');
          if (viewAllLink)   viewAllLink.href            = '/search?q=' + encodeURIComponent(q);
          if (resultsFooter) resultsFooter.style.display = 'block';
          if (youMight)      youMight.style.display      = 'none';
        })
        .catch(function() { showNoResults(q); });
    }

    // ---------- EVENTS ----------

    // FOCUS
    input.addEventListener('focus', function () {
      forceShowResults();
      showDefaultState();
      loadBestsellers();
    });

    // INPUT
    input.addEventListener('input', function () {
      var q = this.value.trim();
      lastQuery = q;
      clearTimeout(debounceTimer);
      if (!q) {
        resetToDefault();
        return;
      }
      hasTyped = true;
      forceShowResults();
      debounceTimer = setTimeout(function () { doSearch(q); }, 280);
    });

    // KEYUP — backup
    input.addEventListener('keyup', function () {
      if (!this.value.trim()) {
        clearTimeout(debounceTimer);
        resetToDefault();
      }
    });

    // OUTSIDE CLICK
    document.addEventListener('click', function (e) {
      if (
        !e.target.closest('.search-bar__top-wrapper') &&
        !e.target.closest('.search-bar__inner')
      ) {
        input.value = '';
        lastQuery   = '';
        closeDropdown();
      }
    });

    // MOBILE: search icon
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-action="toggle-search"]');
      if (toggle) {
        setTimeout(function () {
          var mobileInput = document.querySelector('.search-bar__input');
          if (mobileInput) {
            mobileInput.focus();
            forceShowResults();
            showDefaultState();
            loadBestsellers();
          }
          var mobileWrapper = document.querySelector('.header__search-bar-wrapper');
          if (mobileWrapper) mobileWrapper.classList.add('is-visible');
        }, 400);
      }
    });

    // MOBILE: close button
    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-action="unfix-search"], .search-bar__close-button');
      if (closeBtn) {
        input.value = '';
        lastQuery   = '';
        closeDropdown();
        var mobileWrapper = document.querySelector('.header__search-bar-wrapper');
        if (mobileWrapper) {
          mobileWrapper.classList.remove('is-visible');
          mobileWrapper.classList.remove('is-fixed');
          mobileWrapper.style.display = 'none';
          setTimeout(function () { mobileWrapper.style.display = ''; }, 400);
        }
      }
    });

    // MOBILE: clear button
    var warehouseClear = document.querySelector('.search-bar__input-clear');
    if (warehouseClear) {
      warehouseClear.addEventListener('click', function () {
        input.value = '';
        lastQuery   = '';
        resetToDefault();
      });
    }

    // Hide skeleton
    var skeleton = document.querySelector('.skeleton-container');
    if (skeleton) skeleton.style.display = 'none';

  })();

})();